import React, { useState, useEffect } from 'react';
import { Sidebar, Menu, MenuItem, SubMenu, menuClasses } from 'react-pro-sidebar';
import Logo from '../../static/icons/cia-logo.png';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { SelectButton } from 'primereact/selectbutton';
import { Link, useLocation } from 'react-router-dom';
import DynamicIcon from '../../components/common/DynamicIcon';
import { ArrowLeftToLine, ArrowRightToLine, MenuIcon, PanelLeftClose, PanelRightClose } from 'lucide-react';
import { useDispatch } from 'react-redux';
import { cerrarSesion } from '../../reducers/auth.reducer';
import { validarEntorno } from '../../helpers/validarHost';
import i18next from 'i18next';

/*
const menuConfig = {
    theme: {
        sidebar: {
            backgroundColor: 'white',
            color: 'var(--gray-500)',
        },
        menu: {
            title: {
                color: 'var(--blue-800)',
                backgroundColor: 'var(--blue-50)',
            },
            icon: 'var(--blue-800)',
            hover: {
                backgroundColor: 'var(--gray-100)',
                color: 'var(--blue-800)'
            },
            open: {
                backgroundColor: 'var(--gray-100)',
                color: 'var(--blue-800)',
                iconColor: 'var(--blue-600)',
            },
            disabled: {
                color: 'var(--gray-300)',
            },
        },
    },
    menu: [
        {
            title: 'PRESIDENCIA',
            items: [
                {
                    label: 'Panel',
                    icon: 'layout-grid', // Solo el nombre del icono
                    link: '/dashboard-presidencia',
                },
                {
                    label: 'Administrativo financiero',
                    icon: 'wallet', // Solo el nombre del icono
                    link: '/charts',
                    subItems: [
                        {
                            label: 'Administrativo financiero',
                            horizontal: true,
                            subItems: [
                                { label: 'Solicitar', styles: { color: '#239E23' }, link: '/presidencia/administrativo/solicitar' },
                                { label: 'Procesos', styles: { color: '#213265' }, link: '/presidencia/administrativo/administrar' },
                            ],
                        },
                        {
                            label: 'Contabilidad',
                            horizontal: true,
                            subItems: [
                                { label: 'Solicitar', styles: { color: '#239E23' }, link: '/presidencia/ayf/contabilidad/solicitar' },
                                { label: 'Procesos', styles: { color: '#213265' }, link: '/presidencia/ayf/contabilidad/administrar' },
                                { label: 'Operativo', styles: { color: '#2E86AB' }, link: '/presidencia/ayf/contabilidad/reportes_operativos' },
                            ],
                        },
                        {
                            label: 'Sistema de gestión integral',
                            horizontal: true,
                            subItems: [
                                { label: 'Solicitar', styles: { color: '#239E23' }, link: '/presidencia/ayf/SGI/solicitar' },
                                { label: 'Procesos', styles: { color: '#213265' }, link: '/presidencia/ayf/SGI/administrar' },
                            ],
                        },
                    ],
                },
                {
                    label: 'Comercial',
                    icon: 'handshake', // Solo el nombre del icono
                    link: '/charts',
                    subItems: [
                        {
                            label: 'Gestión comercial',
                            horizontal: true,
                            subItems: [
                                { label: 'Solicitar', styles: { color: '#239E23' }, link: '/presidencia/comercial/gestionComercial/solicitar' },
                                { label: 'Procesos', styles: { color: '#213265' }, link: '/presidencia/comercial/gestionComercial/procesos' },
                            ],
                        },
                        {
                            label: 'Encuestas',
                            horizontal: true,
                            subItems: [
                                { label: 'Solicitar', styles: { color: '#239E23' }, link: '/presidencia/encuestas/solicitar' }
                            ],
                        }
                    ],
                },
                {
                    label: 'Jurídico',
                    icon: 'scale', // Solo el nombre del icono
                    link: '/charts',
                    subItems: [
                        {
                            label: 'Procesos administrativos',
                            horizontal: true,
                            subItems: [
                                { label: 'Solicitar', styles: { color: '#239E23' }, link: '/presidencia/juridico/procesos-administrativos/solicitar' },
                                { label: 'Procesos', styles: { color: '#213265' }, link: '/juridico/procesos-administrativos/administrar' },
                            ],
                        }
                    ],
                },
                {
                    label: 'Teconología de la información',
                    icon: 'server', // Solo el nombre del icono
                    link: '/charts',
                    subItems: [
                        {
                            label: 'Procesos administrativos',
                            horizontal: true,
                            subItems: [
                                { label: 'Solicitar', styles: { color: '#239E23' }, link: '/presidencia/TI/solicitar' },
                                { label: 'Procesos', styles: { color: '#213265' }, link: '/presidencia/TI/administrar' },
                                { label: 'Operativo', styles: { color: '#2E86AB' }, link: '/presidencia/TI/reportes_operativos' }
                            ],
                        }
                    ],
                },

            ],
        },
        {
            title: 'Menú principal',
            items: [
                {
                    label: 'Panel general',
                    icon: 'layout-grid',
                    link: '/dashboard-gerencia',
                },
                {
                    label: 'Análisis de procesos',
                    icon: 'clipboard-check',
                    horizontal: true,
                    subItems: [
                        { label: 'Solicitar', styles: { color: '#239E23' }, link: '/gerencia/auditorias/solicitar' },
                        { label: 'Procesos', styles: { color: '#213265' }, link: '/gerencia/auditorias/procesos' },
                    ],
                },
                {
                    label: 'Operaciones',
                    icon: 'waypoints',
                    horizontal: true,
                    subItems: [
                        { label: 'Solicitar', styles: { color: '#239E23' }, link: '/gerencia/operaciones/solicitar' },
                        { label: 'Procesos', styles: { color: '#213265' }, link: '/gerencia/operaciones/administrar' },
                    ],
                },
                {
                    label: 'Inteligencia',
                    icon: 'user-search',
                    horizontal: true,
                    subItems: [
                        { label: 'Solicitar', styles: { color: '#239E23' }, link: '/gerencia/inteligencia/solicitar' },
                        { label: 'Procesos', styles: { color: '#213265' }, link: '/gerencia/inteligencia/administrar' },
                        { label: 'Reportes', styles: { color: '#E4A731' }, link: '/gerencia/inteligencia/reportes' },
                        { label: 'Operativo', styles: { color: '#2E86AB' }, link: '/gerencia/inteligencia/reportes_operativos' }
                    ],
                },
                {
                    label: 'Investigaciones',
                    icon: 'binoculars',
                    subItems: [
                        {
                            label: 'Investigaciones específicas',
                            horizontal: true,
                            subItems: [
                                { label: 'Solicitar', styles: { color: '#239E23' }, link: '/presidencia/investigaciones/solicitar' },
                                { label: 'Procesos', styles: { color: '#213265' }, link: '/presidencia/investigaciones/procesos' },
                            ],
                        },
                        {
                            label: 'Investigaciones administrativas',
                            horizontal: true,
                            subItems: [
                                { label: 'Solicitar', styles: { color: '#239E23' }, link: '/gerencia/investigaciones-administrativas/solicitar' },
                                { label: 'Procesos', styles: { color: '#213265' }, link: '/gerencia/investigaciones-administrativas/administrar' },
                                { label: 'Reportes', styles: { color: '#E4A731' }, link: '/gerencia/investigaciones-administrativas/reportes' },
                                { label: 'Operativo', styles: { color: '#2E86AB' }, link: '/gerencia/investigaciones-administrativas/reportes_operativos' }
                            ],
                        },
                    ],

                },
                {
                    label: 'Documentos',
                    icon: 'file-text',
                    subItems: [
                        {
                            label: 'Elemento 1',
                            icon: 'signature',
                            subItems: [
                                {
                                    label: 'Elemento 1.1',
                                    icon: 'graduation-cap',
                                    subItems: [
                                        { label: 'Elemento 1.1.1' },
                                        { label: 'Elemento 1.1.2' },
                                    ]
                                },
                            ]
                        },
                        {
                            label: 'Elemento 2',
                            icon: 'book-text',
                            disabled: true,
                        },
                        {
                            label: 'Elemento 3',
                            icon: 'book-text',
                            styles: {
                                backgroundColor: 'var(--blue-900)',
                                color: 'white',
                                iconColor: 'var(--yellow-300)',
                                arrowColor: '#00ff00',
                            },
                            chip: {
                                text: '100+',
                                color: '#ffffff', // color del texto del chip
                                backgroundColor: 'var(--red-500)', // color de fondo del chip
                            },
                            subItems: [
                                { label: 'Elemento 3.1' },
                                { label: 'Elemento 3.2' },
                            ]
                        },
                    ],
                },
            ],
        },
    ],
    usuario: {
        nombre: 'Johnatan Guerrero',
        perfil: 'Aprobador',
    },
    correo: "https://www.ciacosinte.site/crm/upload/correo_electronico.html",
    idioma: {
        "elementos": [{ "id": 2, "label": "Inglés", "value": "en" }, { "id": 1, "label": "Español", "value": "es" }],
        "idiomaUsuario": 1
    },
    logged: true
};
*/

const renderMenuItems = (items, isHorizontal = false, currentPath, collapsed) => {
    return items.map((item) => {
        const itemStyles = item.styles || {}; // estilos individuales del item
        const isActive = currentPath === item.link;
        const hasActiveSubItem = item.subItems && item.subItems.some(subItem => subItem.link === currentPath || (subItem.subItems && subItem.subItems.some(nestedSubItem => nestedSubItem.link === currentPath)));
        const customStyles = {
            backgroundColor: itemStyles.backgroundColor,
            color: itemStyles.color,
            '--icon-color': itemStyles.iconColor,
            '--arrow-color': itemStyles.arrowColor,
            '&:hover': {
                backgroundColor: itemStyles.color,
                color: 'white'
            },

            ...(isHorizontal && {
                borderRadius: '0px',
                fontSize: '12px',
                backgroundColor: 'white',
                cursor: 'pointer',

                '&>.ps-menu-button': {
                    borderTop: `4px solid ${itemStyles.color}`,
                    padding: '.3rem .25rem !important',
                    minHeight: 'auto !important',
                    textAlign: 'center !important',
                    fontWeight: '700 !important',
                    color: isActive ? 'white !important' : itemStyles.color,
                    backgroundColor: isActive ? itemStyles.color + ' !important' : 'transparent !important',

                    '&:hover': {
                        backgroundColor: 'transparent !important',
                        color: 'white !important',
                    },

                    '&>.ps-menu-label': {
                        margin: '0 !important',
                    }
                }
            }),
        };
        const chip = item.chip ? (
            <span
                className="menu__chip"
                style={{
                    color: item.chip.color,
                    backgroundColor: item.chip.backgroundColor
                }}
            >
                {item.chip.text}
            </span>
        ) : null;
        if (item.subItems) {
            return (
                <SubMenu
                    key={item.label}
                    label={item.label}
                    icon={item?.icon && <DynamicIcon name={item.icon} size={18} />} // Usar DynamicIcon
                    style={customStyles}
                    suffix={chip}
                    className={item.horizontal ? 'horizontal' : ''}
                    defaultOpen={hasActiveSubItem}
                    {...(collapsed && { title: item.label })} // Add tooltip when collapsed
                >
                    {renderMenuItems(item.subItems, item.horizontal, currentPath)}
                </SubMenu>
            );
        }
        const isExternal = item.link?.startsWith('http');
        return (
            <MenuItem
                key={item.label}
                icon={item?.icon && (<DynamicIcon name={item.icon} size={18} />)}
                disabled={item.disabled} rootStyles={customStyles}
                suffix={chip}
                active={isActive}
                component={
                    isExternal ? (
                        <a href={item.link} target="_blank" rel="noopener noreferrer" />
                    ) : (
                        <Link to={item.link} />
                    )
                }
                {...(collapsed && { title: item.label })} // Add tooltip when collapsed
            >
                {item.label}
            </MenuItem>
        );
    });
};

export const MenuDinamico = ({ children, menuConfig }) => {
    const [collapsed, setCollapsed] = useState(() => JSON.parse(localStorage.getItem('menuCollapsed')) || false);
    const [toggled, setToggled] = useState(false);
    const [broken, setBroken] = useState(false);
    const [rtl, setRtl] = useState(() => {
        if (menuConfig?.rtl !== undefined && menuConfig?.rtl !== false) {
            return menuConfig.rtl;
        }
        return JSON.parse(localStorage.getItem('menuRtl')) || false;
    });
    const [selectedLanguage, setSelectedLanguage] = useState(menuConfig?.idioma?.elementos.find((element) => element.id === menuConfig.idioma.idiomaUsuario));
    const location = useLocation();
    const currentPath = location.pathname;
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const handleIdiomaChange = async (option) => {
        if (option) {
            setSelectedLanguage(option);
            const data = { hash: window.location.hash, idiomaUsuario: option.id }
            console.log("cambiando idioma", data)
            const request = await validarEntorno('JSON/respuesta_cambiar_idioma.html', 'POST', data);
            if (request.ok) {
                const res = await request.json();
                if (res.estado === 'OK') {
                    await i18next.changeLanguage(option.value);
                    window.location.reload();
                }
            }
        }
    }

    useEffect(() => {
        if (menuConfig?.idioma && Array.isArray(menuConfig.idioma.elementos) && menuConfig.idioma.elementos.length > 0) {
            const idioma = menuConfig.idioma.elementos.find((element) => element.id === menuConfig.idioma.idiomaUsuario);
            if (idioma) {
                setSelectedLanguage(idioma);
                i18next.changeLanguage(idioma.value);
            } else {
                // Default to Spanish if idiomaUsuario is invalid
                const defaultIdioma = menuConfig.idioma.elementos.find((element) => element.value === 'es');
                setSelectedLanguage(defaultIdioma);
                i18next.changeLanguage('es');
            }
        } else {
            // Default to Spanish if idioma or its properties are invalid
            setSelectedLanguage({ id: 1, label: 'Español', value: 'es' });
            i18next.changeLanguage('es');
        }
    }, [menuConfig.idioma]);

    useEffect(() => {
        moment.locale(i18next.language);
    }, [])

    const handleCollapseToggle = () => {
        const newCollapsedState = !collapsed;
        setCollapsed(newCollapsedState);
        localStorage.setItem('menuCollapsed', JSON.stringify(newCollapsedState));
    };

    const handleRtlToggle = () => {
        const newRtlState = !rtl;
        setRtl(newRtlState);
        localStorage.setItem('menuRtl', JSON.stringify(newRtlState));
    };

    const menuItemStyles = {
        root: {
            fontSize: '13px'
        },
        icon: {
            minWidth: collapsed ? '35px' : 'auto',
            width: collapsed ? '35px' : 'auto',
            color: 'var(--icon-color, ' + menuConfig.theme.menu.icon + ')',
            [`&.${menuClasses.disabled}`]: {
                color: menuConfig.theme.menu.disabled.color,
            },
            [`&.${menuClasses.open}`]: {
                color: 'var(--icon-color, ' + menuConfig.theme.menu.open.iconColor + ')',
            },
            [`&.${menuClasses.active}`]: {
                color: 'var(--icon-color, ' + menuConfig.theme.menu.open.iconColor + ')',
            },
        },
        SubMenuExpandIcon: {
            color: 'var(--arrow-color, var(--gray-400))',
            [`&.${menuClasses.open}`]: {
                color: 'var(--arrow-color, ' + menuConfig.theme.menu.hover.color + ')',
            },
        },
        subMenuContent: {
            width: collapsed ? 'auto' : 'auto',
            maxWidth: collapsed ? '260px' : 'auto',
            overflowX: 'auto',
            [`&.${menuClasses.open}`]: {
                marginLeft: collapsed ? '0 !important' : '0',
                marginRight: collapsed && rtl ? '0 !important' : '0',
            }
        },
        button: {
            paddingTop: '0px',
            paddingBottom: '0px',
            height: 'auto',
            minHeight: '35px',
            textAlign: rtl ? 'right' : 'left',
            fontWeight: 400,
            [`&.${menuClasses.disabled}`]: {
                color: menuConfig.theme.menu.disabled.color,
            },
            '&:hover': {
                backgroundColor: menuConfig.theme.menu.hover.backgroundColor,
                color: menuConfig.theme.menu.hover.color,
            },
            [`&.${menuClasses.open}`]: {
                backgroundColor: menuConfig.theme.menu.open.backgroundColor,
                color: menuConfig.theme.menu.open.color,
                fontWeight: 700 + ' !important',
            },
            [`&.${menuClasses.active}`]: {
                backgroundColor: menuConfig.theme.menu.open.backgroundColor,
                color: menuConfig.theme.menu.open.color,
                fontWeight: 700 + ' !important',
            },
        },
        label: ({
            marginRight: rtl ? '0' : '6px',
            marginLeft: rtl ? '6px' : '0',
            whiteSpace: collapsed ? 'nowrap' : 'normal',

        }),
    };

    return (
        <div style={{ display: 'flex', width: '100%', height: '100%', direction: rtl ? 'rtl' : 'ltr' }}>
            <Sidebar
                collapsed={broken ? false : collapsed} // Avoid collapsed view when broken
                toggled={toggled}
                onBackdropClick={() => setToggled(false)}
                onBreakPoint={setBroken}
                rtl={broken ? false : rtl}
                breakPoint="md"
                width={broken ? '70%' : '260px'}
                backgroundColor={menuConfig.theme.sidebar.backgroundColor}
                rootStyles={{
                    backgroundColor: menuConfig.theme.sidebar.backgroundColor,
                    color: menuConfig.theme.sidebar.color,
                    position: 'sticky',
                    top: '0',
                    height: '100vh',
                    zIndex: '1',
                }}
            >
                <div className='h-100' style={{ display: 'flex', flexDirection: 'column' }}>
                    <div className='menu__header'>
                        {!broken && (
                            <div className='header__buttons'
                                style={{
                                    justifyContent: collapsed ? 'center' : 'flex-end',
                                    marginBottom: collapsed ? '0' : 'initial',
                                    padding: '8px 8px 0 8px',
                                }}
                            >
                                <button onClick={handleRtlToggle} className='rtl__button' title='Cambiar dirección'>
                                    {rtl ? <PanelLeftClose size={18} /> : <PanelRightClose size={18} />}
                                </button>
                                <button onClick={handleCollapseToggle} className='collapse__button' title={collapsed ? 'Expandir' : 'Contraer'}>
                                    {collapsed ? <ArrowRightToLine size={18} /> : <ArrowLeftToLine size={18} />}
                                </button>
                            </div>
                        )}

                        <div className='header__content'>
                            <img
                                src={menuConfig?.logo || Logo}
                                alt='cia logo'
                                className='logo'
                            />
                        </div>

                    </div>
                    <div className='menu__content'>
                        {menuConfig?.menu?.map((section) => (
                            <React.Fragment key={section.title}>
                                {!collapsed && (
                                    <span className='menu__title' style={{ ...menuConfig.theme.menu.title }}>
                                        {section.title}
                                    </span>
                                )}
                                <Menu menuItemStyles={menuItemStyles}>
                                    {renderMenuItems(section.items, false, currentPath, collapsed)}
                                </Menu>
                            </React.Fragment>
                        ))}
                    </div>
                    <div className={`menu__footer ${collapsed ? 'collapsed' : ''}`}>
                        {!collapsed ? (
                            <div className='footer__content'>
                                <div className='menu__actions'>
                                    <div className='language__selector'>
                                        {menuConfig?.idioma && Array.isArray(menuConfig.idioma.elementos) && menuConfig.idioma.elementos.length > 0 && (
                                            <SelectButton
                                                value={selectedLanguage.value}
                                                options={menuConfig.idioma.elementos}
                                                onChange={(e) => handleIdiomaChange(menuConfig.idioma.elementos.find((element) => element.value === e.value))}
                                                optionLabel="label"
                                                optionValue="value"
                                                placeholder="Select a Language"
                                                style={{ flexDirection: rtl ? 'row-reverse' : 'row' }}
                                            />
                                        )}
                                    </div>
                                    <Link className='action__button' title='Perfil' to='/perfil'>
                                        <DynamicIcon name="User" size={18} />
                                    </Link>
                                    <a className='action__button' title='Correo' href={menuConfig?.correo} target='_blank'>
                                        <DynamicIcon name="Mail" size={18} />
                                    </a>
                                </div>

                                <div className='menu__user'>
                                    <div className='user__info'>
                                        <span className='user__name'>{menuConfig?.usuario?.nombre}</span>
                                        <span className='user__profile'>{menuConfig?.usuario?.perfil}</span>
                                    </div>
                                    <div>
                                        <button className='logout__button' onClick={() => dispatch(cerrarSesion())} title='Cerrar sesión'>
                                            <DynamicIcon name="LogOut" size={18} />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        ) : (

                            <Menu menuItemStyles={menuItemStyles}>
                                <SubMenu icon={<DynamicIcon name="user" size={18} />}  >
                                    <MenuItem icon={<DynamicIcon name="User" size={18} />} component={<Link to='/perfil' />} >Perfil</MenuItem>
                                    <MenuItem icon={<DynamicIcon name="Mail" size={18} />} component={<a href={menuConfig?.correo} target='_blank' />} >Correo</MenuItem>
                                    <MenuItem icon={<DynamicIcon name="LogOut" size={18} color="var(--red-500)" />}> Cerrar sesión </MenuItem>
                                </SubMenu>
                            </Menu>
                        )}
                    </div>
                    <div className="menu_register">
                        CIA © {moment().format("YYYY")} - {t("dashboard.por")} COSINTE LTDA
                    </div>
                </div>
                <button
                    className='collapse-button'
                    onClick={() => setCollapsed(!collapsed)}
                    style={{
                        display: 'none',
                    }}
                >
                    {collapsed ? 'Expand' : 'Collapse'}
                </button>
            </Sidebar>

            <main id='db' className='dashboard__container d-flex'>
                <div>
                    {broken && (
                        <button className="mobile__toggle__button" onClick={() => setToggled(!toggled)}>
                            <MenuIcon />
                        </button>
                    )}
                </div>
                {children}
                <p id="footer">
                    {/*CIA © {moment().format("YYYY")} - {t("dashboard.por")} COSINTE LTDA*/}
                </p>
            </main>
        </div>

    );
};
